import Button from "./Button";

const ContentModal = ({
  isOpen,
  onClose,
  showClose,
  title,
  content,
  showSubmit = false,
  buttonText = "",
  onButtonClick = null,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl p-6 relative flex flex-col max-h-[90vh]">
        {/* Close Button */}
        {showClose && (
          <Button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
          >
            ✕
          </Button>
        )}

        {/* Title */}
        <h2 className="text-2xl font-semibold mb-4">{title}</h2>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto text-gray-700 pr-2 mb-4">
          {content}
        </div>

        {/* Submit Button at the bottom */}
        {showSubmit && (
          <div className="flex justify-end mt-4">
            <Button
              onClick={onButtonClick}
              className="bg-btn text-white px-4 py-2 rounded hover:opacity-90 transition"
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentModal;
